import React from 'react';
import { TokenUpdate } from './TokenUpdate';
import { TokenType, TokensVService } from '../../../services/V3/gozer';
import { handleErrorToast } from '../../shared/Functions';
import { Dialog, DialogContent, DialogTitle, Grid } from '@material-ui/core';

export function WalletUpdate({ show, hide, paymentMethod, account, itemAdded, success, fail }) {
    const completeAch = (form) => {
        TokensVService
            .tokensVUpdateToken(account.id ?? "", paymentMethod.id,
                {
                    firstName: form.firstName,
                    lastName: form.lastName,
                    streetAddress: form.streetAddress,
                    city: form.city,
                    state: form.state,
                    zip: form.zip
                })
            .then(token => {
                success("Update Completed")
                itemAdded()
            }).catch(err => err.message !=="Not Found" && fail(handleErrorToast(err)))
    }

    const completeCC = (form) => {
        TokensVService
            .tokensVUpdateToken(account.id ?? "", paymentMethod.id,
                {
                    firstName: form.firstName,
                    lastName: form.lastName,
                    streetAddress: form.streetAddress,
                    city: form.city,
                    state: form.state,
                    zip: form.zip,
                    expirationMonth: form.expirationMonth,
                    expirationYear: form.expirationYear
                })
            .then(token => {
                success("Update Completed")
                itemAdded()
            }).catch(err => err.message !=="Not Found" && fail(handleErrorToast(err)))
    }
    
    return (
        <Dialog onClose={() => hide} open={show}>
            <DialogTitle>Update Payment Method</DialogTitle>
            <DialogContent>
                <Grid>
                    <Grid xs={12}>
                        <div className="container-border">
                            {paymentMethod.tokenType === TokenType.CC ?
                                <TokenUpdate
                                    updateToken={{...paymentMethod}}
                                    isCCToken={true}
                                    onSubmit={completeCC}
                                    onCancel={hide} /> :
                                <TokenUpdate
                                    updateToken={{...paymentMethod}}
                                    isCCToken={false}
                                    onSubmit={completeAch}
                                    onCancel={hide} />}
                        </div>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>)
}
